import { AbstractControl } from '@angular/forms';

export function linkValidation(control: AbstractControl): {[key: string]: boolean} | null {
  // http://, https://, ftp://
  const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;

  const correct = control.value?.match(urlPattern);
  return correct ? null : {invalidLink: true};
}
